<template>
  <div class="subscr-preview-base" :style="styles">
    <h4 v-html="resultData.result_title"></h4>
    <p v-html="resultData.result_text"></p>
    <div class="btn-wrap">
      <div class="bluerd-text">あなたは、人生を自分らしく生きるために生まれてきました。周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。しかし、そのためにストレスをたるはずです。<br><br>あなたは、人生を自分らしく生きるために生まれてきました。<br>周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。<br><br>あなたは、人生を自分らしく生きるために生まれてきました。周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。しかし、そのためにストレスをたるはずです。</div>
      <div class="inner">
<!--        <div v-if="showLineBtn" class="subscr-preview-base__line-btn" @click="onClickLine">
          <div class="inn">
            <img src="/static/img/recommend/lp/ottimo/icon_line.png" alt="" width="40">
            友だち登録で無料で占う
          </div>
        </div>-->
        <lp-base-button
          design="fill"
          :label="buttonFace"
          :color-scheme="colorData"
          @clicked="onBtnClick"
        />
        <!-- <p @click="onClickShot">月額登録せずに占う</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'SubscrFortunePreview',
  components: {
    LpBaseButton,
  },
  props: {
    buttonFace: {
      type: String,
      default: '占い放題に登録して<br>結果をみる'
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    resultData: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      require: true,
    },
    colorData: {
      type: Object,
      default(){
        return {
          head: 'black',
          font: 'black',
          previewBg: 'white',
          previewBorder: 'black',
        }
      }
    },
    showLineBtn: {
      type: Boolean,
      default: false,
    },
    index: Number,
  },
  computed: {
    styles(){
      return {
        '--head': this.colorData.head,
        '--font': this.colorData.font,
        '--preview-bg': this.colorData.previewBg,
        '--preview-border': this.colorData.previewBorder,
      }
    },
  },
  methods: {
    onBtnClick(){
      const param = {
        'event_category': `LP${this.lpId}basicresult-subsc-button`,
        'event_label': `point${this.index}`
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(this.resultData.link_url)
    },
    onClickLine() {
      const param = {
        'event_category': `LP${this.lpId}basicresult-LINE-campaign-button`,
        'event_label': this.resultData.menu_id
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams('/lp/campaign/1')
    },
    onClickShot() {
      const param = {
        'event_category': `LP${this.lpId}basicresult-paid-content-button`,
        'event_label': this.resultData.menu_id
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      const url = `/recommend/${this.resultData.menu_id}/detail`
      location.href = this.$handoverParams(url)
    },
  },
}
</script>

<style scoped lang="scss">
$l_col_head: var(--head);
$l_col_font: var(--font);
$l_col_preview_bg: var(--preview-bg);
$l_col_preview_border: var(--preview-border);

.subscr-preview-base {
  color: $l_col_font;
  background: $l_col_preview_bg;
  border: 1px solid $l_col_preview_border;
  width: 100%;
  padding: 24px 20px;
  h4 {
    color: $l_col_head;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 20px;
    text-align: center;
  }
  > p {
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    margin: 0 0 20px;
  }
  .btn-wrap {
    color: #303030;
    position: relative;
    overflow: hidden;
    .inner {
      width: 100%;
      max-width: 320px;
      margin: auto;
      padding: 60px 12px;
      position: relative;
      z-index: 11;
      > p {
        margin: 20px 0 0;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        text-align: center;
        text-decoration: underline;
      }
      /deep/ .baseButton__button {
        min-width: auto;
        padding: 0 32px;
        line-height: 18px;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(90deg, #93C0F4 2%, #CD96F9 52.09%, #FF6AB2 98.17%);
      }
    }
    .bluerd-text {
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      right: 0;
      overflow: hidden;
      font-size: 14px;
      line-height: 24px;
      text-align: justify;
      filter: blur(4px);
      color: #AAB2BD;
      pointer-events: none;
    }

  }
  &__line-btn {
    background: linear-gradient(90deg, #5AC363 1.67%, #90E800 98.7%);
    border-radius: 50px;
    margin: 0 0 17px;
    padding: 3px;
    cursor: pointer;
    .inn {
      background: #FFFFFF;
      border-radius: 50px;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5AC363;
      height: 49px;
      img {
        vertical-align: middle;
        margin: 0 15px 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/SubscrFortunePreview.vue